const hoverTriggers = document.getElementsByClassName('js-hover-trigger');
const videoItems = document.getElementsByClassName('c-media__video');

export function pauseAllVideos() {
  [...videoItems].forEach(el => {
    el.pause();
  });
}

export function initPlayOnHover() {
  [...hoverTriggers].forEach(el => {
    el.addEventListener('mouseover', () => {
      pauseAllVideos();
      // Get the video element the is the previous sibling of the hover trigger
      const video = el.previousElementSibling;
      video.play();
    });
    el.addEventListener('mouseleave', () => {
      pauseAllVideos();
    });
  });
  [...videoItems].forEach(el => {
    el.addEventListener('mouseover', () => {
      pauseAllVideos();
      el.play();
    });
  });
}



// WEBPACK FOOTER //
// ./src/scripts/modules/hovers.js